export const WH_SORTS = [["created_desc", "Najnovšie"], ["delivery_desc", "Dodané (najnovšie)"], ["delivery_asc", "Dodané (najstaršie)"], ["stock_low", "Stav zásob ↑ (najnižší)"], ["stock_high", "Stav zásob ↓ (najvyšší)"], ["price_asc", "Cena ↑"], ["price_desc", "Cena ↓"], ["name_asc", "Názov A–Z"]];

const cd = (x, y) => (x || "").localeCompare(y || "");

export const sortWarehouse = (items, sort) => [...items].sort((a, b) => {
  switch (sort) {
    case "delivery_desc": return ((b.delivery_date ? 1 : 0) - (a.delivery_date ? 1 : 0)) || cd(b.delivery_date, a.delivery_date);
    case "delivery_asc": return ((b.delivery_date ? 1 : 0) - (a.delivery_date ? 1 : 0)) || cd(a.delivery_date, b.delivery_date);
    case "stock_low": return Number(a.qty || 0) - Number(b.qty || 0);
    case "stock_high": return Number(b.qty || 0) - Number(a.qty || 0);
    case "price_asc": return Number(a.purchase_price || 0) - Number(b.purchase_price || 0);
    case "price_desc": return Number(b.purchase_price || 0) - Number(a.purchase_price || 0);
    case "name_asc": return (a.name || "").localeCompare(b.name || "", "sk");
    default: return cd(b.created_at, a.created_at);
  }
});
